import { useState, useEffect } from "react";
import axios from "axios";
import { Divider } from "@mui/material";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import clock_3 from "../../../assets/images/NewEvent/clock_3.svg";
import user_status from "../../../assets/images/NewEvent/user_status.svg";
import list from "../../../assets/images/NewEvent/list.svg";
import sp from "../../../assets/images/Footer/sp.svg";
import { Link } from "react-router-dom";

function extractFirstImageAndText(htmlContent) {
  // Tìm thẻ <img> đầu tiên
  const imgRegex = /<img[^>]*src="([^"]*)"[^>]*>/;
  const match = imgRegex.exec(htmlContent);

  let firstImage = null;
  if (match) {
    firstImage = match[1]; // Lấy src của thẻ <img> đầu tiên
  }

  // Xóa thẻ <img> đầu tiên khỏi nội dung HTML
  const textWithoutFirstImage = htmlContent.replace(imgRegex, "");

  return { text: textWithoutFirstImage, firstImage };
}

function getCategoryName(categories, ids) {
  const arrIds = ids
    ? ids
        .split(",")
        .map((num) => Number(num))
        .filter((n) => n > 0)
    : [];
  const cat = categories.find(
    (item) => item.id == (arrIds.length > 0 ? arrIds[0] : 0)
  );
  return cat?.name ?? "";
}

const fetchDataCategory = async () => {
  const response = await axios.get(
    "https://api-bluerise.bluerise.com.vn/category/get-all"
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

const fetchDataNews = async () => {
  const response = await axios.post(
    "https://api-bluerise.bluerise.com.vn/news/get-publish",
    {
      keyword: "",
      type: 1,
      status: 2,
      pageNum: 1,
      pageSize: 50,
    }
  );
  if (response.status === 200) {
    return response.data;
  }
  return null;
};

function renderNewsRow(categories, newsData) {
  let { text, firstImage } = extractFirstImageAndText(newsData.shortContent);
  return (
    <div className=" w-full gap-3 hover:border hover:border-blue-500  rounded-[8px] border border-solid border-gray-300 shadow-custom-light ">
      <div className="w-full flex flex-col gap-3">
        <div className="overflow-hidden rounded-[8px]">
          <Link to={`/tintuc-chitiet/${newsData.slug}`}>
            <img
              src={firstImage}
              className="w-full h-auto object-cover rounded-[8px] transform transition-transform duration-300 ease-in-out hover:scale-110"
              alt="Thumbnail"
            />
          </Link>
        </div>

        <div className="w-full px-[24px] py-[16px] flex flex-col gap-3">
          <div>
            <p className="text-[16px] h-20 font-semibold text-[#1F1F1F] hover:text-[#053CC8] cursor-pointer">
              <Link to={`/tintuc-chitiet/${newsData.slug}`}>
                <p className="text-[#053CC8]"> {newsData.title}</p>
              </Link>
            </p>
          </div>

          <div className="flex items-center justify-between w-full md:flex-col lg:flex-row md:gap-1 md:items-center md:justify-center md:h-28 lg:h-8">
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={user_status} alt="bg" />
              </div>
              <p className="font-extrabold md:text-[16px]">{newsData.author}</p>
            </div>
            <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
              <div className="w-[16px] h-[16px]">
                <img src={clock_3} alt="mj" />
              </div>
              <p className="font-extrabold md:text-[16px]">
                {new Date(newsData.publishDate).toLocaleDateString()}
              </p>
            </div>
          </div>
          <div>
            <Divider />
          </div>

          <div className="w-full flex items-center gap-2 text-[#919191] text-[14px] font-normal">
            <div>
              <img src={list} alt="vf" />
            </div>
            <p>{getCategoryName(categories, newsData.categories)}</p>
          </div>

          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="h-32 md:h-32 overflow-auto overflow-x-hidden"
          />
        </div>
      </div>
    </div>
  );
}

export default function News() {
  const [activeTab, setActiveTab] = useState("latest");
  const [currentPage, setCurrentPage] = useState(1);
  const [categories, setCategories] = useState(null);
  const [articles, setArticles] = useState([]);

  // Dữ liệu mẫu cho các bài viết, mỗi bài có đường dẫn riêng

  const itemsPerPage = 9;
  const totalPages = Math.ceil(articles.length / itemsPerPage);

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePageClick = (page) => {
    setCurrentPage(page);
  };

  const renderPageNumbers = () => {
    let pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - 1 && i <= currentPage + 1)
      ) {
        pageNumbers.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`px-3 py-1 rounded-lg ${
              i === currentPage
                ? "bg-blue-100 text-blue-500 font-semibold"
                : "text-gray-700"
            }`}
          >
            {i}
          </button>
        );
      } else if (i === currentPage - 2 || i === currentPage + 2) {
        pageNumbers.push(
          <span key={i} className="px-2 text-gray-500">
            ...
          </span>
        );
      }
    }
    return pageNumbers;
  };

  const currentArticles = articles.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    fetchDataCategory().then((data) => {
      setCategories(data);
    });
    fetchDataNews().then((data) => {
      setArticles(data);
    });
  }, []);

  return (
    <div className="w-full">
      <div className="container mx-auto p-3">
        <div className="mt-4">
          <div className="flex flex-col gap-2 py-2">
            <div className="flex items-center gap-1 justify-center">
              <img src={sp} alt="bh" />
              <p className="text-[#053CC8] text-[32px] font-semibold">
                TIN TỨC MỚI NHẤT
              </p>
            </div>
          </div>

          {activeTab === "latest" && (
            <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {currentArticles &&
                currentArticles.map((newData, index) => (
                  <div key={index} className="w-full gap-3 rounded-[8px] ">
                    {renderNewsRow(categories, newData)}
                  </div>
                ))}
            </div>
          )}
          {currentArticles && (
            <div className="flex flex-col items-center justify-center md:justify-between mt-4">
              <div className="w-full">
                <Divider />
              </div>
              <div className="w-full flex items-center justify-center md:justify-between py-5">
                <button
                  onClick={handlePrevious}
                  disabled={currentPage === 1}
                  className="px-4 py-2 items-center gap-2 border rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50 hidden md:flex"
                >
                  <FaArrowLeft /> Trước
                </button>
                <div className="flex items-center space-x-1">
                  {renderPageNumbers()}
                </div>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                  className="px-4 py-2 items-center gap-2 border rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50 hidden md:flex"
                >
                  Sau <FaArrowRight />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
